/// <amd-module name="Test/PassRateChartView/ControllerViews/PassRateChartView" />
import * as Utils_Number from "Analytics/Shared/Utils/Number";
import * as React from "react";
import { DonutChartVisual, IDonutChartVisualDatum, IDonutChartVisualProps } from "ReportsCommon/DonutChartVisual/Components/DonutChartVisual";
import { TestReportColorPalette } from "Test/common-util/Common";
import { PassRateChartActionsCreator } from "Test/PassRateChartView/Actions/PassRateChartActionsCreator";
import * as Resources from "Test/PassRateChartView/Resources";
import { IPassRateChartState, PassRateChartStore } from "Test/PassRateChartView/Stores/PassRateChartStore";
import { Components, css, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

export interface IPassRateChartViewProps extends IVssComponentProperties {
    store: PassRateChartStore;
    actionCreator: PassRateChartActionsCreator;
}

export class PassRateChartView extends VssComponent<IPassRateChartViewProps, IPassRateChartState> {
    constructor(props: IPassRateChartViewProps) {
        super(props);
        this.state = {} as IPassRateChartState;
    }

    public componentDidMount() {
        super.componentDidMount();
        if (this.props) {
            this.props.store.addChangedListener(this._onStoreUpdate);
            this.setState(this.props.store.getState());
        }
    }

    public componentWillUnmount() {
        if (this.props) {
            this.props.store.removeChangedListener(this._onStoreUpdate);
        }
    }

    public render() {
        return <DonutChartVisual className={css("pass-rate-chart-view-section", this.props.className)} {...this._getPieChartProps()} />;
    }

    protected _getPieChartProps(): IDonutChartVisualProps {
        const props: IDonutChartVisualProps = {
            title: Resources.TestsInPipelineText,
            titleId: "pass-rate-chart-view-title",
            ariaLabelledBy: "pass-rate-chart-view-title"
        };

        if (this.state.testOutcomeMetricsData) {
            props.chartTitle = Resources.PassRateChartAriaLabelText;
            props.chartData = this._getDonutChartData();
            props.scalarContent = this.state.testOutcomeMetricsData.passPercentage;
            props.scalarLabel = Resources.PassRateAndResultsText;
            props.auxiliaryScalarContent = Utils_Number.formatAbbreviatedNumber(this.state.testOutcomeMetricsData.totalCount).toLocaleString();
            props.auxiliaryScalarLabel = Resources.TotalTestResultsText;
            props.pageContext = this.context.pageContext;
        }

        return props;
    }

    protected _getDonutChartData(): IDonutChartVisualDatum[] {
        return [
            {
                name: Resources.PassedTestsText,
                legendLabel: Resources.TestOutcome_Passed,
                color: TestReportColorPalette.Passed,
                y: this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.passedCount : 0,
                legendDisplayValue: Utils_Number.formatAbbreviatedNumber(
                    this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.passedCount : 0
                )
            } as IDonutChartVisualDatum,
            {
                name: Resources.FailedTestsText,
                legendLabel: Resources.TestOutcome_Failed,
                color: TestReportColorPalette.Failed,
                y: this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.failedCount : 0,
                legendDisplayValue: Utils_Number.formatAbbreviatedNumber(
                    this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.failedCount : 0
                )
            } as IDonutChartVisualDatum,
            {
                name: Resources.TestOutcome_NotImpacted,
                legendLabel: Resources.TestOutcome_NotImpacted,
                color: TestReportColorPalette.NotImpacted,
                y: this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.notImpactedCount : 0,
                legendDisplayValue: Utils_Number.formatAbbreviatedNumber(
                    this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.notImpactedCount : 0
                )
            } as IDonutChartVisualDatum,
            {
                name: Resources.TestOutcome_NotExecuted,
                legendLabel: Resources.TestOutcome_NotExecuted,
                color: TestReportColorPalette.NotExecuted,
                y: this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.notExecutedCount : 0,
                legendDisplayValue: Utils_Number.formatAbbreviatedNumber(
                    this.state.testOutcomeMetricsData ? this.state.testOutcomeMetricsData.notExecutedCount : 0
                )
            } as IDonutChartVisualDatum
        ];
    }

    private _onStoreUpdate = () => {
        this.setState(this.props.store.getState());
    };
}

Components.add("PassRateChartView", PassRateChartView);
